export default __webpack_public_path__ + "images/dropdown_portal-bfdaf3a8944410b9aba21584154d5114.svg";